module.exports = __webpack_public_path__ + "img/dashboardChicken.a1add471.png";